import produce from 'immer';
import { cloneDeep, omit } from 'lodash';
import { JNode, Section } from '../../types';

export function updateJDocWithBlocks(jdoc: JNode, sections: Section[]): JNode {
  return produce(jdoc, (jdoc) => {
    jdoc.content = sections.map((section) => {
      return {
        type: {
          name: 'section',
        },
        attributes: {
          id: section.id,
        },
        content: section.blocks.map((block) => {
          let blockContent = block.content;
          if (blockContent.type === 'image' && blockContent.file) {
            blockContent = omit(blockContent, 'file');
          }
          return {
            type: {
              name: 'block',
            },
            attributes: {
              id: block.id,
              content: cloneDeep(blockContent),
              layout: cloneDeep(block.layout),
            },
            content: [],
          };
        }),
      };
    });
  });
}
